var _a;
import { createActions } from 'redux-actions';
export var startScan = (_a = createActions('START_SCAN', 'STOP_SCAN', 'END_SCAN_SEARCH'), _a.startScan), stopScan = _a.stopScan, endScanSearch = _a.endScanSearch;
